export default {
    gridOptions: {
        itemsPerPage: 10,
        itemsPerPageOptions: [5, 10, 20]
    }
}
